<template>
  <div class="mb-8 relative carousel__wrapper">
    <Carousel
      id="thumbnails"
      :wrap-around="false"
      :v-model="currentSlide"
      :breakpoints="breakpoints"
      snapAlign="start"
      :itemsToShow="2"
      ref="myCarousel"
    >
      <Slide
        v-for="categoryList in categoryLists"
        :key="categoryList.category_id"
      >
        <div
          class="carousel__item rounded border active:bg-primary-light hover:bg-primary-light px-5 mx-2 py-2 border-turquoise-medium cursor-pointer shrink-0 text-blog-13-sm md:text-blog-16 font-semibold"
          :id="categoryList.category_id"
          v-bind:class="
            categoryList.category_id == 'all' ? 'bg-primary-light' : ''
          "
          @click="activeTab($event)"
        >
          {{ categoryList.name }}
        </div>
      </Slide>

      <template #addons>
        <Navigation />
      </template>
    </Carousel>
    <span class="absolute w-12 h-full top-0 right-0 scroll-shadow"></span>
  </div>
</template>

<script setup>
import { Carousel, Pagination, Slide, Navigation } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

const emit = defineEmits(["emitCategoryId"]);
defineProps({
  categoryLists: {
    type: Array,
  },
});
const currentSlide = shallowRef(0);
const breakpoints = {
  // 700px and up
  700: {
    itemsToShow: 3,
    snapAlign: "start",
  },
  // 1024 and up
  1024: {
    itemsToShow: 7,
    snapAlign: "start",
  },
};

function activeTab(e) {
  let siblings = document.querySelectorAll(".carousel__item");
  for (let item of siblings) {
    item.classList.remove("bg-primary-light");
  }
  e.currentTarget.classList.add("bg-primary-light");
  emit("emitCategoryId", e.currentTarget.getAttribute("id"));
}
</script>
<style scoped>
ul {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  transform: translate3d(0, 0, 0);
}

ul::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
.carousel__slide {
  width: auto !important;
}

.carousel__item:hover {
  -webkit-transition: background-color 300ms ease;
  -ms-transition: background-color 300ms ease;
  transition: background-color 300ms ease;
}

.carousel__wrapper {
  width: calc(100% + 16px);
}

.scroll-shadow {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}
</style>

<style>
.carousel__prev,
.carousel__next {
  display: none;
}
</style>
